







import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class ImagePreview extends Vue {
  @Prop({ required: true })
  file: File

  preview: string | null = null

  @Watch('file')
  onFileChanged() {
    this.load()
  }

  created() {
    this.load()
  }

  load() {
    const reader = new FileReader()
    reader.onload = (e: ProgressEvent) => {
      if (e.target === null) {
        return
      }

      // `result` must be string when `readAsDataURL` called.
      this.preview = (e.target as FileReader).result as string
    }
    reader.readAsDataURL(this.file)
  }

  get backgroundStyle(): string {
    return `background-image: url('${this.preview}');`
  }
}
